"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfNurseProfileDto = instanceOfNurseProfileDto;
exports.NurseProfileDtoFromJSON = NurseProfileDtoFromJSON;
exports.NurseProfileDtoFromJSONTyped = NurseProfileDtoFromJSONTyped;
exports.NurseProfileDtoToJSON = NurseProfileDtoToJSON;
exports.NurseProfileDtoToJSONTyped = NurseProfileDtoToJSONTyped;
/**
 * Check if a given object implements the NurseProfileDto interface.
 */
function instanceOfNurseProfileDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    return true;
}
function NurseProfileDtoFromJSON(json) {
    return NurseProfileDtoFromJSONTyped(json, false);
}
function NurseProfileDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
    };
}
function NurseProfileDtoToJSON(json) {
    return NurseProfileDtoToJSONTyped(json, false);
}
function NurseProfileDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
    };
}
//# sourceMappingURL=NurseProfileDto.js.map